"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _button = _interopRequireDefault(require("@clayui/button"));

var _icon = _interopRequireDefault(require("@clayui/icon"));

var _react = _interopRequireDefault(require("react"));

var _Context = _interopRequireDefault(require("./Context"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * © 2019 Liferay, Inc. <https://liferay.com>
 *
 * SPDX-License-Identifier: BSD-3-Clause
 */
var ICON_MAP = {
  danger: 'exclamation-full',
  info: 'info-circle',
  success: 'check-circle-full',
  warning: 'warning-full'
};

var ClayModalHeader = function ClayModalHeader(_ref) {
  var children = _ref.children;

  var _React$useContext = _react.default.useContext(_Context.default),
      onClose = _React$useContext.onClose,
      spritemap = _React$useContext.spritemap,
      status = _React$useContext.status;

  return _react.default.createElement("div", {
    className: "modal-header"
  }, status && _react.default.createElement("div", {
    className: "modal-title-indicator"
  }, _react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: ICON_MAP[status]
  })), _react.default.createElement("div", {
    className: "modal-title"
  }, children), _react.default.createElement(_button.default, {
    "aria-label": "close",
    className: "close",
    displayType: "unstyled",
    onClick: onClose
  }, _react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: "times"
  })));
};

var _default = ClayModalHeader;
exports.default = _default;